// Lightweight mobile utilities used across the app. Safe no-ops on web.
export type HapticLevel = 'light' | 'medium' | 'heavy'

const MobileUtils = {
  // Best-effort detection of Capacitor runtime; defaults to web (false)
  isNative(): boolean {
    try {
      // Capacitor injects a global Capacitor object
      return typeof window !== 'undefined' && typeof (window as any).Capacitor !== 'undefined'
    } catch {
      return false
    }
  },

  // Optional haptic feedback; no-op if unavailable
  async hapticFeedback(level: HapticLevel = 'light'): Promise<void> {
    try {
      // Dynamically import if present to avoid bundling errors when not installed
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const mod = await import('@capacitor/haptics')
      const Haptics = mod?.Haptics
      const ImpactStyle = mod?.ImpactStyle
      if (Haptics && ImpactStyle) {
        const style = level === 'heavy' ? ImpactStyle.Heavy : level === 'medium' ? ImpactStyle.Medium : ImpactStyle.Light
        await Haptics.impact({ style })
        return
      }
    } catch {
      // Ignore if plugin isn't available
    }
    // Fallback: no-op
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.debug(`[MobileUtils] hapticFeedback(${level}) noop`)
    }
  }
}

export default MobileUtils
